import searchSelector from './searchSelector.vue';
export default searchSelector;



// WEBPACK FOOTER //
// ./src/components/searchSelector/index.js